const HierarchyType = Object.freeze({
    BASE: 'BASE',
    SERVICES: 'SERVICES',
});

export function getHierarchy(value) {
    if (Object.values(HierarchyType).includes(value)) {
        return HierarchyType[value];
    }
    return null;
}

export default HierarchyType;
